import MdaeAccordion from "./component";
import { IAccordionOptions } from "devextreme-react/accordion";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeAccordionProps extends IAccordionOptions {
    mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeAccordion;